import { search } from 'services/analytics/events/search';
import { SearchProps } from 'services/analytics/events/propertyTypes';
import { trackingDocumentListViewKeywordSearch } from 'services/analytics';

export const trackingSearchRequest = (operation: any) => {
  const metadata: SearchProps = {
    '[Search] Term': operation.variables.searchString,
  };
  return search.keywordSearch(metadata);
};

export const trackingSearchResponse = (operation: any, response: any) => {
  const searchTerm = operation.variables.searchString;
  const totalItems = response.data.me.search.pageInfo.total;
  const metadata: SearchProps = {
    '[Search] Term': searchTerm,
  };
  search.viewResults(metadata);
  trackingDocumentListViewKeywordSearch(searchTerm, totalItems);
  return;
};

export const trackingSearchClear = () => {
  return search.clear();
};
